<template>
  <div>
    <form autocomplete="off"
          class="no-padding"
          @submit.prevent="addDocument()">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label class="label"
                   :for="`doc_${ _uid }`">Documento</label>
            <select :id="`doc_${ _uid }`"
                    ref="falecido_doc"
                    v-model="documento.tipo_documento"
                    :class="`custom-select custom-select-sm selectDocumentos addDocs_${propOrdem}`"
                    :disabled="!show_input && !!documentos && !!documentos.length"
                    name="doc"
                    @change="changeTipo">
              <option selected
                      :value="null">
                Escolha o Documento
              </option>
              <option v-for="tipo in tiposSelect()"
                      :key="tipo.key"
                      :value="tipo.key">
                {{ tipo.label }}
              </option>
            </select>
          </div>
        </div>
        <!-- Todos tipos que tem apenas um campo -->
        <div v-if="documento.tipo_documento && show_input"
             class="col-12 col-sm-4 col-md-3">
          <div class="form-group">
            <label class="label text-capitalize"
                   :for="`numero_documento_${ _uid }`">{{ getDocumentLabel(documento.tipo_documento) }}</label>
            <input :id="`numero_documento_${ _uid }`"
                   v-model="documento.numero"
                   v-mask="{ mask: mask }"
                   class="form-control form-control-sm"
                   :placeholder="placeholder"
                   :maxlength="maxlength"
                   name="numero"
                   type="text">
          </div>
        </div>
        <div v-if="documento.tipo_documento === 'CTPS' || documento.tipo_documento === 'PASSAPORTE'"
             class="col-12 col-sm-2 col-md-1">
          <div class="form-group">
            <label class="label"
                   for="serie_ctps">Série</label>
            <input id="serie_ctps"
                   v-model="documento.serie"
                   class="form-control form-control-sm"
                   name="serie"
                   type="text">
          </div>
        </div>

        <div v-if="documento.tipo_documento === 'DOC_ESTRANGEIRO' || documento.tipo_documento === 'NAO_IDENTIFICADO'"
             class="col-12 col-sm-3 col-md-3">
          <div class="form-group">
            <label class="label"
                   for="descricao_doc">Tipo de documento</label>
            <input id="descricao_doc"
                   v-model="documento.descricao"
                   class="form-control form-control-sm"
                   name="descricao"
                   type="text">
          </div>
        </div>

        <div v-if="documento.tipo_documento === 'RG'"
             class="col-4 col-sm-4 col-md-2">
          <div class="form-group">
            <label class="label"
                   :for="`codigo_orgao_emissor_${ _uid }`">Orgão Emissor</label>
            <select :id="`codigo_orgao_emissor_${ _uid }`"
                    v-model="documento.codigo_orgao_emissor"
                    class="custom-select custom-select-sm"
                    name="codigo_orgao_emissor">
              <option v-for="orgao in selectsOptions.orgao_emissor"
                      :key="orgao.codigo"
                      :value="orgao.codigo">
                {{ orgao.descricao }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="documento.tipo_documento === 'CTPS' || documento.tipo_documento === 'RG'"
             class="col-3 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   :for="`uf_emissor_${ _uid }`">UF Emissor</label>
            <select :id="`uf_emissor_${ _uid }`"
                    v-model="documento.uf_emissor"
                    class="custom-select custom-select-sm"
                    name="uf_emissor">
              <option v-for="state in selectsOptions.states"
                      :key="state.id"
                      :value="state.uf">
                {{ state.uf }}
              </option>
            </select>
          </div>
        </div>

        <div v-if="exibirDataEmissao()"
             class="col-2 col-md-2 col-sm-3">
          <div class="form-group">
            <label class="label"
                   :for="`data_emissao_${ _uid }`">Data de Emissão</label>
            <input :id="`data_emissao_${ _uid }`"
                   v-model="documento.data_emissao"
                   v-validate="`date_format:yyyy-MM-dd|date_between:${ initDate },${limitDate}`"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('data_emissao') }"
                   name="data_emissao"
                   type="date">
            <small v-if="errors.has('data_emissao')"
                   class="invalid-feedback">{{ errors.first('data_emissao') }}</small>
          </div>
        </div>

        <div v-if="documento.tipo_documento === 'CNH'"
             class="col-2 col-md-3 col-sm-3">
          <div class="form-group">
            <label class="label"
                   :for="`data_habilitacao_${ _uid }`">Data 1ª habilitação</label>
            <input :id="`data_habilitacao_${ _uid }`"
                   v-model="documento.data_emissao"
                   v-validate="`date_format:yyyy-MM-dd|date_between:${ initDate },${limitDate}`"
                   class="form-control form-control-sm"
                   :class="{ 'is-invalid': errors.has('data_habilitacao') }"
                   name="data_habilitacao"
                   type="date">
            <small v-if="errors.has('data_habilitacao')"
                   class="invalid-feedback">{{ errors.first('data_habilitacao') }}</small>
          </div>
        </div>

        <div v-if="documento.tipo_documento"
             class="col-12">
          <div class="form-group">
            <button class="btn-add-doc btn btn-sm btn-block btn-outline-primary"
                    type="submit"
                    :disabled="!documento.numero">
              <IconSvg class="icon-add icon--sm mr-1"
                       icon="add" />
              Adicionar documentos
            </button>
          </div>
        </div>
      </div>
    </form>
    <BoxDocumento v-for="(doc, index) in documentos"
                  :key="index"
                  :documento="doc"
                  @remove="removeDocument(doc, index)" />
  </div>
</template>

<script>
  import { getDocuments, getDocumentLabel, getOrgaoEmissor } from "@/constants/documentosPessoais"
  import BrazilianStates from "@/constants/brazilianStates"
  import BoxDocumento from '@/components/SofiaRei/Obito/BoxDocumento.vue'
  import moment from "moment"

  export default {
    name: "Documentos",
    components: { BoxDocumento },
    props: {
      documentos: { type: Array },
      readOnly: { type: Boolean, default: ()=> false},
      tipoRegistro: { type: String },
      propHideSwal: {type: Boolean, default: false},
      propData: { type: Object, default: () => ({}) },
      propOrdem: { type: Number, default: 0},
    },
    data () {
      return {
        selectsOptions: {
          states: [...BrazilianStates],
          orgao_emissor: []
        },
        documento: {},
        mask: '',
        placeholder: '',
        maxlength: '20',
        show_input: true,
        getDocumentLabel,
        initDate: moment('1500-01-01').format('YYYY-MM-DD'),
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD'),
      }
    },
    watch: {
      tipoRegistro () {
        if (this.selectsOptions.orgao_emissor.length) {
          this.documento = { tipo_documento: 'RG', codigo_orgao_emissor: this.selectsOptions.orgao_emissor[0].codigo }
        } else {
          this.documento = { tipo_documento: null }
        }
      },

      documentos () {
        if (this.documentos && !this.documentos.length && this.selectsOptions.orgao_emissor.length) {
          this.documento = { tipo_documento: 'RG', codigo_orgao_emissor: this.selectsOptions.orgao_emissor[0].codigo }
        }  else {
          this.documento = { tipo_documento: null }
        }
      }
    },
    async beforeMount () {
      this.selectsOptions.orgao_emissor = await getOrgaoEmissor()

      if (this.documentos && this.documentos.length) {
        this.documento.tipo_documento = null
        this.show_input = false
      } else {
        this.documento = { tipo_documento: 'RG', codigo_orgao_emissor: this.selectsOptions.orgao_emissor[0].codigo }
        this.changeTipo()
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        if (this.propData.data_nascimento) {
          this.initDate = moment(this.propData.data_nascimento, 'DD/MM/YYYY').add(-1, 'days').format('YYYY-MM-DD')
        }

        if (this.propData.registro && this.propData.registro.data_ocorrido && (this.tipoRegistro == "O" || this.tipoRegistro == "NT")) {
          this.limitDate = moment(this.propData.registro.data_ocorrido).add(1, 'days').format('YYYY-MM-DD')
        }
      },
      async addDocument () {
        if (this.tipoRegistro !== 'O') {
          this.show_input = false
        }
        this.documento.data_emissao = this.documento.data_emissao ? moment(String(this.documento.data_emissao), 'YYYY-MM-DD').format('YYYY-MM-DD') : null
        this.$emit('DocumentoAdded',  this.documento)

        if (this.propHideSwal) {
          const doc = document.querySelector('#doc')

          if (doc) doc.focus()

          return
        }

        objSwal.success.title = "Documento Cadastrado com Sucesso"
        objSwal.success.text = ''
        this.documento = { tipo_documento: null }

        Swal.fire(objSwal.success).then(() => {
          const doc = document.querySelector('#doc')
          const selectDocs = document.querySelector(`.addDocs_${this.propOrdem}`)

          if (doc) {
            doc.focus()
          }
          else if (selectDocs) {
            selectDocs.focus()
          }
        })

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          this.init()

          if (btnConfirm) btnConfirm.focus()
        }, 300)
      },
      async removeDocument (documento, index) {
        this.show_input = false
        documento.localId = index
        this.$emit('DocumentoRemoved', documento)

        if (this.propHideSwal) {
          if (this.documentos && !this.documentos.length && this.selectsOptions.orgao_emissor && this.selectsOptions.orgao_emissor.length) {
            this.documento = { tipo_documento: 'RG', codigo_orgao_emissor: this.selectsOptions.orgao_emissor[0].codigo }
            this.changeTipo()

            this.show_input = true
            this.init()
          } else {
            this.show_input = true
            this.init()
          }

          return
        }

        objSwal.success.title = "Removido com Sucesso"
        objSwal.success.text = ''

        Swal.fire(objSwal.success).then(() => {
          const doc = document.querySelector('#doc')
          const selectDocs = document.querySelector(`.addDocs_${this.propOrdem}`)

          if (doc) {
            doc.focus()
          }
          else if (selectDocs) {
            selectDocs.focus()
          }
        })

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          this.show_input = true
          this.init()

          if (btnConfirm) btnConfirm.focus()
        }, 300)
      },
      tiposSelect () {
        let tipos = []
        if (this && this.tipoRegistro == "NT") {
          tipos.push({ key: "RG", label: "RG" })
        } else {
          tipos = getDocuments()
          if (this.tipoRegistro == "Casamento" || this.tipoRegistro == "O") {
            const index = tipos.findIndex(tipo => tipo.key == "CERT_DE_NASCIMENTO")
            tipos.splice(index, 1)
          }
        }

        return tipos
      },
      exibirDataEmissao () {
        let exibir = false
        if (['RG', 'CTPS', 'CARTEIRA_DE_MARITIMO', 'PASSAPORTE', 'TITULO_DE_ELEITOR'].indexOf(this.documento.tipo_documento) >= 0 ) {
          exibir = true
        }
        return exibir
      },
      changeTipo () {
        this.show_input = false
        const tipo = this.documento.tipo_documento

        this.documento = {
          tipo_documento: tipo
        }


        const dadosInputs = this.getMaskAndPlaceholder(tipo)

        this.mask = dadosInputs.mask
        this.placeholder = dadosInputs.placeholder
        if (dadosInputs.maxlength != null) {
          this.maxlength = dadosInputs.maxlength
        }
        else {
          this.maxlength = '20'
        }


        setTimeout(() => {
          this.show_input = true
          this.init()
        }, 100)
      },
      getMaskAndPlaceholder (tipo) {
        let mask, placeholder, maxlength

        switch (tipo) {

        case 'CTPS':
          mask = ['AA999999', '99999999']
          placeholder = 'AA999999 ou 99999999'
          break
        case 'PASSAPORTE':
          mask = ['AA999999']
          placeholder = 'AA999999'
          break
        case 'RG':
          placeholder = 'Digite o número'
          maxlength = '13'
          break
        default:
          placeholder = 'Digite o número'
          break
        }

        return {
          mask,
          placeholder,
          maxlength
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

  .btn-add-doc:hover:not(:disabled)> [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
</style>
